"use client";
import { createContext, PropsWithChildren, useContext } from "react";

import { mobileContent, mobileImage, mobileSlider } from "./mobilePayload";
import { Resources } from "./types";

export type MobileResources = Resources<
  typeof mobileContent,
  typeof mobileImage,
  typeof mobileSlider
>;

export const MobileResourceContext = createContext<MobileResources>(undefined!);

export function MobileResourceProvider(
  props: PropsWithChildren<{ resources: MobileResources }>
) {
  return (
    <MobileResourceContext.Provider value={props.resources}>
      {props.children}
    </MobileResourceContext.Provider>
  );
}

export function useMobileContentResource() {
  return useContext(MobileResourceContext).content;
}

export function useMobileImageResource() {
  return useContext(MobileResourceContext).image;
}

export function useMobileImageSlider() {
  return useContext(MobileResourceContext).slider;
}
